import { render, staticRenderFns } from "./SPBG.vue?vue&type=template&id=497ed23f"
import script from "./SPBG.vue?vue&type=script&lang=js"
export * from "./SPBG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports